import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["aspectRatio", "appearance", "children"];
import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Brand } from '@mediahuis/chameleon-theme-wl/icons';
import Base from '../Base';
import Icon from '../Icon';
import system from '../../system';
import styles from './index.module.scss';
var SYSTEM_PROPS = ['flexProps', 'positioningProps', 'marginProps', 'paddingProps', 'widthProps', 'floatProps'];
var Placeholder = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _aspectRatios, _appearances;

  var aspectRatio = _ref.aspectRatio,
      appearance = _ref.appearance,
      children = _ref.children,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  var _system = system(props, SYSTEM_PROPS),
      className = _system[0],
      style = _system[1],
      rest = _system[2];

  var aspectRatios = (_aspectRatios = {}, _aspectRatios[styles.aspect4_5] = aspectRatio === '4:5', _aspectRatios[styles.aspect1_1] = aspectRatio === '1:1', _aspectRatios[styles.aspect3_2] = aspectRatio === '3:2', _aspectRatios[styles.aspect4_3] = aspectRatio === '4:3', _aspectRatios[styles.aspect16_9] = aspectRatio === '16:9', _aspectRatios);
  var appearances = (_appearances = {}, _appearances[styles.placeholder] = appearance === 'placeholder', _appearances[styles.plain] = appearance === 'plain', _appearances);
  return /*#__PURE__*/React.createElement(Base, _extends({
    ref: ref,
    className: cx(styles.root, appearances, aspectRatios, className),
    style: style
  }, rest), appearance === 'placeholder' && /*#__PURE__*/React.createElement(Icon, {
    className: styles.logo,
    as: Brand,
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.content),
    "aria-hidden": "true"
  }, children));
});
Placeholder.displayName = 'Placeholder';
Placeholder.identifier = Placeholder.displayName;
Placeholder.clonableProps = SYSTEM_PROPS;
Placeholder.defaultProps = {
  appearance: 'placeholder'
};
export default Placeholder;